/* tslint:disable */
/* eslint-disable */
/**
 * authentik
 * Making authentication simple.
 *
 * The version of the OpenAPI document: 2024.12.3
 * Contact: hello@goauthentik.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ErrorReportingConfigFromJSON, ErrorReportingConfigToJSON, } from './ErrorReportingConfig';
import { CapabilitiesEnumFromJSON, CapabilitiesEnumToJSON, } from './CapabilitiesEnum';
/**
 * Check if a given object implements the Config interface.
 */
export function instanceOfConfig(value) {
    if (!('errorReporting' in value) || value['errorReporting'] === undefined)
        return false;
    if (!('capabilities' in value) || value['capabilities'] === undefined)
        return false;
    if (!('cacheTimeout' in value) || value['cacheTimeout'] === undefined)
        return false;
    if (!('cacheTimeoutFlows' in value) || value['cacheTimeoutFlows'] === undefined)
        return false;
    if (!('cacheTimeoutPolicies' in value) || value['cacheTimeoutPolicies'] === undefined)
        return false;
    if (!('cacheTimeoutReputation' in value) || value['cacheTimeoutReputation'] === undefined)
        return false;
    return true;
}
export function ConfigFromJSON(json) {
    return ConfigFromJSONTyped(json, false);
}
export function ConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'errorReporting': ErrorReportingConfigFromJSON(json['error_reporting']),
        'capabilities': (json['capabilities'].map(CapabilitiesEnumFromJSON)),
        'cacheTimeout': json['cache_timeout'],
        'cacheTimeoutFlows': json['cache_timeout_flows'],
        'cacheTimeoutPolicies': json['cache_timeout_policies'],
        'cacheTimeoutReputation': json['cache_timeout_reputation'],
    };
}
export function ConfigToJSON(json) {
    return ConfigToJSONTyped(json, false);
}
export function ConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'error_reporting': ErrorReportingConfigToJSON(value['errorReporting']),
        'capabilities': (value['capabilities'].map(CapabilitiesEnumToJSON)),
        'cache_timeout': value['cacheTimeout'],
        'cache_timeout_flows': value['cacheTimeoutFlows'],
        'cache_timeout_policies': value['cacheTimeoutPolicies'],
        'cache_timeout_reputation': value['cacheTimeoutReputation'],
    };
}
